import root from '@/router/routes/root.routes'
import register from '@/router/routes/register.routes'
import issued from '@/router/routes/issued.routes'
import configuration from '@/router/routes/configuration.routes'
import proforms from '@/router/routes/proforms.routes'
import help from '@/router/routes/help.routes'
import debug from '@/router/routes/debug.routes'
import home from '@/router/routes/home.routes'
import support from 'profiles/eurobits/router/routes/support.routes'
import verifactu from '@/router/routes/verifactu.routes'

export default [
  ...root,
  ...register,
  ...issued,
  ...configuration,
  ...proforms,
  ...help,
  ...debug,
  ...home,
  ...support,
  ...verifactu
]
